import { render, staticRenderFns } from "./SvgLegendCategoryIcon.vue?vue&type=template&id=3537f466"
import script from "./SvgLegendCategoryIcon.vue?vue&type=script&lang=js"
export * from "./SvgLegendCategoryIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgLegendCategoryIcon.vue?vue&type=style&index=0&id=3537f466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports